export default "__VITE_ASSET__jBKgHS85__"